"use client";

import { c as _c } from "react/compiler-runtime";
import NetworkHealthCTA from "@/components/header/NetworkHealthCTA";
import HeaderSearchButton from "@/components/header/header-search/HeaderSearchButton";
import { Bars3Icon } from "@heroicons/react/24/outline";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
interface SmallScreenHeaderProps {
  readonly onMenuToggle: () => void;
  readonly isMenuOpen: boolean;
}
export default function SmallScreenHeader(t0) {
  const $ = _c(11);
  const {
    onMenuToggle,
    isMenuOpen
  } = t0;
  const pathname = usePathname();
  const isHomeRoute = pathname === "/";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href="/" className="tw-flex tw-items-center"><Image unoptimized={true} loading="eager" priority={true} alt="6529Seize" src="/6529.svg" className="tw-h-10 tw-w-10 tw-flex-shrink-0 tw-transition-all tw-duration-100 desktop-hover:hover:tw-scale-[1.02] desktop-hover:hover:tw-shadow-[0_0_20px_10px_rgba(255,215,215,0.3)]" width={40} height={40} /></Link>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isHomeRoute) {
    t2 = isHomeRoute && <NetworkHealthCTA />;
    $[1] = isHomeRoute;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HeaderSearchButton wave={null} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isMenuOpen ? "Close menu" : "Open menu";
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Bars3Icon className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-300" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onMenuToggle || $[6] !== t4) {
    t6 = <button onClick={onMenuToggle} className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-text-iron-300 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-primary-400 desktop-hover:hover:tw-bg-iron-700 desktop-hover:hover:tw-text-iron-50" aria-label={t4}>{t5}</button>;
    $[5] = onMenuToggle;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t6) {
    t7 = <header className="tailwind-scope tw-sticky tw-top-0 tw-z-50 tw-flex-shrink-0 tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-iron-800 tw-bg-black"><div className="tw-flex tw-h-16 tw-items-center tw-justify-between tw-px-5">{t1}<div className="tw-flex tw-items-center tw-gap-3">{t2}{t3}{t6}</div></div></header>;
    $[8] = t2;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}